export class LanguageGroup {
  idLanguageGroup: number;
  name: string;
  orphan: boolean;

  constructor(
    idLanguageGroup: number,
    name: string,
    orphan: boolean,
  ) {
    this.idLanguageGroup = idLanguageGroup;
    this.name = name;
    this.orphan = orphan;
  }

  static fromRaw(raw: any): LanguageGroup {
    return new LanguageGroup(
      Number(raw.idLanguageGroup),
      String(raw.name),
      Boolean(raw.orphan),
    );
  }

  clone(): LanguageGroup {
    return new LanguageGroup(
      this.idLanguageGroup,
      this.name,
      this.orphan,
    );
  }

  toPayload(): any {
    return {
      idLanguageGroup: this.idLanguageGroup,
      name: this.name,
      orphan: this.orphan,
    };
  }
}
